var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"statistic-container"},[_c('strong',{staticClass:"statistic-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"statistics-separator"}),_vm._v(" "),_c('span',{staticClass:"statistic-value"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efedbdf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statistics-cell.vue
// module id = null
// module chunks = 